import React from "react";
export default class MrlForm extends React.Component{
    constructor(props){
        super(props);

        this.state = {
            corso: {style: {overflowX:'hidden'}, value: ''},
            piaciuto: {style: {}, value: ''},
            consiglio: {style: {}, value: ''},
            amici: {style: {}, value: '--'},
            nome: {style: {}, value: ''},
            cognome: {style: {}, value: ''},
            numero: {style: {}, value: ''},
            email: {style: {}, value: ''},
            privacy: {style: {}, value: ''},
            stars: {style: {}, value: 1},//0,
            isSubmitting: false,
            courses: [],
        };
    }

    componentDidMount(){
        this.getOptions()
    }

    updateField(field, e){
        var currentState = this.state;
        currentState[field].value = e.target.value;
        this.setState(currentState);
    }

    async formSumbmitted(e){
        e.preventDefault();
        if(!this.state.isSubmitting)
        {
            var current_state = this.state;
            current_state.isSubmitting = true;
            this.setState(current_state);

            // Qua salva i dati
            await this.saveData(
                () => {
                    // Qua apri modal    
                    var thankYouModal = new window.bootstrap.Modal('#thank-you-modal', {backdrop:'static', focus:true, keyboard:false});
                    thankYouModal.toggle();
                }
            );
        }
        else
        {
            console.error("Già in corso!");
        }
    }

    saveData(callback){
        var current_state = this.state;
        var form_body = Object.keys(current_state).reduce(function(result, key) {
            result[key] = current_state[key].value ?? current_state[key];
            return result;
        }, {});

        const requestOptions = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(form_body)
        };
        fetch('https://www.mattiamerlini.it/api/reviews/reviews/create', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                const data = isJson && await response.json();

                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }

                // Apri modal
                callback();
            })
            .catch(error => {
                //callback()
                console.error('There was an error!', error);
            });
    }

    loadOptions(callback){
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' }
        };
        fetch('https://www.mattiamerlini.it/api/reviews/courses', requestOptions)
            .then(async response => {
                const isJson = response.headers.get('content-type')?.includes('application/json');
                var data = isJson && await response.json();

                // check for error response
                if (!response.ok) {
                    // get error message from body or default to response status
                    const error = (data && data.message) || response.status;
                    return Promise.reject(error);
                }
                
                callback(data);
            })
            .catch(error => {
                //callback()
                console.error('There was an error!', error);
                callback([]);
            });
    }

    getOptions(){
        this.loadOptions(r => {
            var current_state = this.state;
            current_state.courses = r;
            this.setState(current_state);
        })
    }

    render(){

        
        
        
        return(
            <form className='testimonianze-form mb-5' onSubmit={e => this.formSumbmitted(e)}>
                <div className='mb-5'>
                    <div className="row g-3 align-items-center mb-5">
                        <div className="col-md-6">
                            <label htmlFor="corso" className="col-form-label" aria-describedby='corsoHelp'>A quale corso hai partecipato?</label>
                            <div id="corsoHelp" className="form-text">Se non trovi il nome esatto seleziona "Altro corso"</div>
                        </div>
                        <div className="col-md-6">
                            <select defaultValue={this.state.corso.value} onChange={e => this.updateField('corso', e)} className="form-select form-select-lg mb-5" id="corso" name='corso' aria-label="Corso al quale hai partecipato" required style={this.state.corso.style}>
                                <option hidden>Seleziona un corso</option>                               
                                {
                                    this.state.courses.map(a => {return (<option value={a.id} key={a.id}>{a.name} {a.location}</option>)})
                                }
                                
                            </select>
                        </div>
                    </div>


                    <div className="row g-3 align-items-center mb-5">
                        <div className="col-md-6">
                            <label htmlFor="stars" className="col-form-label" aria-labelledby='starsHelp'>Che voto dai complessivamente al corso?</label>
                            <div id="starsHelp" className="form-text">Quanto sei soddisfatto da 1 a 5?</div>
                        </div>
                        <div className="col-md-6">
                            <div className="row mt-5 mb-5">
                                <div className="col star">
                                    <input type="radio" className="btn-check" name="stars" value={1} id="1star" autoComplete="off" onChange={e => this.updateField('stars', e)}/>
                                    <label style={{color:"gold", fontSize:'2em'}} className={this.state.stars.value >= 1 ? 'bi bi-star-fill' : 'bi bi-star'} htmlFor="1star"></label>
                                </div>
                                <div className="col star">
                                    <input type="radio" className="btn-check" name="stars" value={2} id="2stars" autoComplete="off" onChange={e => this.updateField('stars', e)}/>
                                    <label style={{color:"gold", fontSize:'2em'}} className={this.state.stars.value >= 2 ? 'bi bi-star-fill' : 'bi bi-star'} htmlFor="2stars"></label>
                                </div>
                                <div className="col star">
                                    <input type="radio" className="btn-check" name="stars" value={3} id="3stars" autoComplete="off" onChange={e => this.updateField('stars', e)}/>
                                    <label style={{color:"gold", fontSize:'2em'}} className={this.state.stars.value >= 3 ? 'bi bi-star-fill' : 'bi bi-star'} htmlFor="3stars"></label>
                                </div>
                                <div className="col star">
                                    <input type="radio" className="btn-check" name="stars" value={4} id="4stars" autoComplete="off" onChange={e => this.updateField('stars', e)}/>
                                    <label style={{color:"gold", fontSize:'2em'}} className={this.state.stars.value >= 4 ? 'bi bi-star-fill' : 'bi bi-star'} htmlFor="4stars"></label>
                                </div>
                                <div className="col star">
                                    <input type="radio" className="btn-check" name="stars" value={5} id="5stars" autoComplete="off" onChange={e => this.updateField('stars', e)}/>
                                    <label style={{color:"gold", fontSize:'2em'}} className={this.state.stars.value >= 5 ? 'bi bi-star-fill' : 'bi bi-star'} htmlFor="5stars"></label>
                                </div>
                            </div>
                        </div>
                    </div>

                    

                    <div className="row g-3 align-items-center mb-5">
                        <div className="col-md-6">
                            <label htmlFor="piaciuto" className="col-form-label" aria-labelledby='piaciutoHelp'>Cosa ti è piaciuto di Mattia?</label>
                            <div id="piaciutoHelp" className="form-text">Se ti va, scrivi due parole su Mattia. Ti è piaciuto il suo approccio con te, i suoi esempi e il suo modo di semplificare le cose difficili?</div>
                        </div>
                        <div className="col-md-6">
                            <textarea style={this.state.piaciuto.style} defaultValue={this.state.piaciuto.value} onChange={e => this.updateField('piaciuto', e)} id="piaciuto" name='piaciuto' rows={6} className="form-control" placeholder='Scrivi qui due parole su ciò che ti è piaciuto di più del corso e di Mattia &#128521;' required/>
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mb-5">
                        <div className="col-md-6">
                            <label htmlFor="corso" className="col-form-label" aria-labelledby='consiglioHelp'>Consiglieresti Mattia ad altre persone?</label>
                            <div id="consiglioHelp" className="form-text">Ti piacerebbe che qualche tuo amico o amica facesse un corso insieme a Mattia?</div>
                        </div>
                        <div className="col-md-6">
                            <div className='row' style={this.state.consiglio.style}>
                                <div className='col d-grid'>
                                    <input defaultValue="Sì" checked={this.state.consiglio.value === "Sì"} onChange={e => this.updateField('consiglio', e)} type="radio" className="btn-check mb-5" name="consiglio" id="sì" autoComplete="off" required/>
                                    <label className="btn btn-outline-success mb-5 btn-lg" htmlFor="sì">Sì</label>
                                </div>
                            
                                <div className='col d-grid'>
                                    <input defaultValue="No" checked={this.state.consiglio.value === "No"} onChange={e => this.updateField('consiglio', e)} type="radio" className="btn-check mb-5" name="consiglio" id="no" autoComplete="off" required/>
                                    <label className="btn btn-outline-danger mb-5 btn-lg" htmlFor="no">No</label>
                                </div>
                            </div>						
                        </div>
                    </div>
                    {/*<div className="row g-3 align-items-center mb-5">
                        <div className="col-md-6">
                            <label htmlFor="amici" className="col-form-label" aria-labelledby='amiciHelp'>A chi lo consiglieresti?</label>
                            <div id="amiciHelp" className="form-text">Tra i tuoi amici, chi vorresti far partecipare ad un corso di Mattia? Se ti va lasciami pure dei nomi, dei numeri di telefono, email, ... oppure ci sentiamo in seguito e me li passerai &#128521;</div>
                        </div>
                        <div className="col-md-6">
                            <textarea defaultValue={this.state.amici.value} onChange={e => this.updateField('amici', e)} id="amici" name='amici' rows={6} className="form-control" placeholder='Scrivi qualche nome di persone che potrebbero trovare utile un corso di Mattia.' required/>
                        </div>
                    </div>
                    */}
                </div>
                
                <div className='mb-5'>
                    <h3>Ti va se mi salvo i tuoi contatti?</h3>
                    <p>Sono disponibile per darti ulteriori chiarimenti, materiale o consigli anche dopo il corso. Se per te può essere utile, scrivi qua sotto i tuoi contatti.</p>
                </div>
                <div className='mb-5'>
                    <div className="row g-3 align-items-center mb-5">
                        <div className="col-md-6">
                            <label htmlFor="nome" className="col-form-label" aria-labelledby='nomeHelp'>Come ti salvo?</label>
                            <div id="nomeHelp" className="form-text">Lasciami pure il nome.</div>
                        </div>
                        <div className="col-md-6">
                            <input style={this.state.nome.style} defaultValue={this.state.nome.value} onChange={e => this.updateField('nome', e)} type="text" id="nome" name='nome' className="form-control" placeholder='Il tuo nome' required/>
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mb-5">
                        <div className="col-md-6">
                            <label htmlFor="cognome" className="col-form-label" aria-labelledby='cognomeHelp'>Il cognome</label>
                            <div id="cognomeHelp" className="form-text">Il tuo cognome.</div>
                        </div>
                        <div className="col-md-6">
                            <input style={this.state.cognome.style} defaultValue={this.state.cognome.value} onChange={e => this.updateField('cognome', e)} type="text" id="cognome" name='cognome' className="form-control" placeholder='Il tuo cognome' required/>
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mb-5">
                        <div className="col-md-6">
                            <label htmlFor="numero" className="col-form-label" aria-labelledby='numeroHelp'>Numero per scriverti su WhatsApp <i className="bi bi-whatsapp"></i></label>
                            <div id="numeroHelp" className="form-text">Il tuo numero di telefono per sentirci su WhatsApp</div>
                        </div>
                        <div className="col-md-6">
                            <input style={this.state.numero.style} defaultValue={this.state.numero.value} onChange={e => this.updateField('numero', e)} type="tel" id="numero" name='numero' className="form-control" placeholder='Il tuo  numero di cellulare' required/>
                        </div>
                    </div>
                    <div className="row g-3 align-items-center mb-5">
                        <div className="col-md-6">
                            <label htmlFor="email" className="col-form-label" aria-labelledby='emailHelp'>Il tuo indirizzo email</label>
                            <div id="emailHelp" className="form-text">L'email risulta comoda quando ti invio le diapositive del corso, dei riassunti, ecc ...</div>
                        </div>
                        <div className="col-md-6">
                            <input style={this.state.email.style} defaultValue={this.state.email.value} onChange={e => this.updateField('email', e)} type="email" id="email" name='email' className="form-control" placeholder='Il tuo indirizzo email' required/>
                        </div>
                    </div>
                </div>
                <div className="col-12 text-start mb-5">
                    <div className="form-check">
                        <input defaultValue="Privacy accettata" style={this.state.privacy.style} checked={this.state.privacy.value === "Privacy accettata"} onChange={e => {
                            if(e.target.checked)
                            {
                                // Da selezionare nello state
                                this.updateField('privacy', e);
                            }
                            else
                            {
                                // Da deselezionare nello state
                                this.updateField('privacy', {target:{value:''}});
                            }
                            
                        }} className="form-check-input" type="checkbox" id="privacy" name="privacy" required/>
                        <label className="form-check-label privacy" htmlFor="privacy">
                            Ho preso visione dell'<a href="https://mattiamerlini.it/Privacy-Merlini-Mattia-Impresa-Individuale.pdf" rel="noreferrer" target="_blank">Informativa Privacy</a> ed accetto che la mia recensione sia usata da Mattia Merlini, stampata e/o pubblicata. In cambio potrò ricevere aggiornamenti, consigli e materiale da Mattia.
                        </label>
                    </div>
                </div>
                <div className='mb-5 d-grid'>
                    <button type="submit" className="btn btn-outline-primary btn-lg">Ok, ho fatto!</button>
                </div>
                <div className='modal' id='thank-you-modal'>
					<div className="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl">
						<div className="modal-content text-center">
							<div className="modal-body">
								<h2>Grazie mille {this.state.nome.value}!</h2>
								<p className='mb-5'>
									Premendo sul pulsante qua sotto potrai avere i miei contatti per sentirci!
								</p>
								<p className='mb-5'>
									<a className='btn btn-lg btn-outline-primary' href='https://www.bigliettidavisitanfc.it/profile/ZwYorDSN80mD/jSmG6PzEg==/' rel='noreferrer' target='_blank'>Vedi contatti</a>
								</p>
                                <p className='mb-5'>
                                    Oppure <a href={`${process.env.PUBLIC_URL}/`}>guarda le altre recensioni</a>
                                </p>
							</div>
							
						</div>
						</div>
				</div>
            </form>
        );
    }
}